import type { FlowChildNode } from '../../../edit/flowGraph';

/**
 * The placed definition's name to show on a step, or null when the step's title already is that name.
 *
 * A step's label replaces the definition name in its title, so with a label set the name would otherwise appear nowhere on
 * the canvas. Editor placements carry it as `node_definition_name`; instance rows carry only `name`.
 */
export const shownDefinitionName = (
  node: Pick<FlowChildNode, 'node_definition_name' | 'name'> | undefined,
  title: string | null | undefined
): string | null => {
  const definitionName = node?.node_definition_name || node?.name || null;
  return definitionName && definitionName !== title ? definitionName : null;
};
